import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api' });

// Token payload'ni dekod qilish — xavfsiz, atob xatolari ignore.
function getTokenPayload() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    return JSON.parse(atob(token.split('.')[1]));
  } catch { return null; }
}

// Saqlangan klub ID — faqat sof son. Boshqa narsa (null/"", "all", "abc") → null.
function readSelectedLabId() {
  try {
    const v = localStorage.getItem('selected_lab_id');
    if (!v || v === 'all') return null;
    if (!/^\d+$/.test(v)) return null;
    return v;
  } catch { return null; }
}

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // X-Lab-Id — FAQAT ega (role=owner) uchun. Xodim backend tomondan token.lab_id
  // ishlatadi, header ignore qilinadi.
  const payload = getTokenPayload();
  if (payload?.role === 'owner') {
    const sel = readSelectedLabId();
    if (sel) config.headers['X-Lab-Id'] = sel;
    // null bo'lsa — "Hammasi" rejimi, header yuborilmaydi (backend "all" sifatida qabul qiladi)
  }

  return config;
});

// 401 kelganda tokenni tozalab, login sahifasiga qaytaramiz.
// 403 "tegishli emas" — saqlangan selected_lab_id'ni tozalab, "Hammasi"ga qaytaramiz
// (saqlangan klub endi egaga tegishli emas yoki o'chirilgan).
let redirecting = false;
api.interceptors.response.use(
  r => r,
  err => {
    const status = err?.response?.status;
    const errorMsg = err?.response?.data?.error || '';

    if (status === 401 && !redirecting) {
      redirecting = true;
      localStorage.removeItem('token');
      if (!window.location.hash.startsWith('#/login')) {
        window.location.replace('/admin/#/login');
      }
      return Promise.reject(err);
    }

    // Saqlangan selected_lab_id endi noto'g'ri bo'lishi mumkin:
    //  • 403 "Bu klub sizga tegishli emas" — klub egaga tegishli emas
    //  • 404 "Lab not found" / "Klub topilmadi" — klub o'chirilgan
    //  • 400 "Invalid lab_id" — ID formati noto'g'ri (eski bugli bo'lsa)
    // Bu holatlarda tanlovni tozalab, "Hammasi"ga qaytib, sahifani qayta
    // yuklaymiz. X-Lab-Id yuborilgan so'rovlar uchun — buzilgan tanlovni
    // davomli ushlab turish o'rniga toza boshlashga chaqiramiz.
    const labMismatch =
      (status === 403 && /tegishli emas|not_your_lab|forbidden_lab/i.test(errorMsg)) ||
      (status === 404 && /lab_not_found|klub topilmadi|lab not found/i.test(errorMsg)) ||
      (status === 400 && /invalid_lab_id|lab_id/i.test(errorMsg));
    const sentLabHeader = !!err?.config?.headers?.['X-Lab-Id'];
    if (labMismatch && sentLabHeader) {
      try { localStorage.removeItem('selected_lab_id'); } catch {}
      // Infinite loop oldini olish uchun bitta marta reload
      if (!window.__lab_reset_in_progress) {
        window.__lab_reset_in_progress = true;
        setTimeout(() => window.location.reload(), 100);
      }
    }

    return Promise.reject(err);
  }
);

export default api;
